
import { createContext, useContext } from "react"
import { SubscriptionProcessAction, SubscriptionProcessAsyncActions, SubscriptionProcessSyncActions } from "./actions"
import { SubscriptionProcessState } from "./types"

const contextErrorMessage = 'useSubscriptionProcess must be used within a SubscriptionProcessProvider'

export interface SubscriptionProcessContextProps extends SubscriptionProcessAsyncActions, SubscriptionProcessSyncActions {
  state: SubscriptionProcessState
  dispatch: React.Dispatch<SubscriptionProcessAction>
}

export const SubscriptionProcessContext = createContext<SubscriptionProcessContextProps | undefined>(undefined)

export const useSubscriptionProcess = () => {
  const context = useContext(SubscriptionProcessContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }
  return context
}

export const useSubscriptionProcessActions = () => {
  const context = useContext(SubscriptionProcessContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }

  const {
    state,
    dispatch,
    ...actions
  } = context

  return actions
}
